import React from 'react';
import { KeyFacts, type KeyFact } from './key-facts';
import { AttentionQueue, type AttentionQueueItem } from './attention-queue';

export interface RecordOverviewProps {
  facts: KeyFact[];
  attention: readonly AttentionQueueItem[];
  attentionError?: React.ReactNode;
  children: React.ReactNode;
  rail?: React.ReactNode;
}

/** Overview-only composition. Keep the record header and shared tabs outside it. */
export function RecordOverview({
  facts,
  attention,
  attentionError,
  children,
  rail,
}: RecordOverviewProps) {
  return (
    <div className="min-w-0 space-y-4" data-record-overview>
      <KeyFacts facts={facts} columns={5} emphasis="strong" />
      {attentionError}
      <AttentionQueue title="Needs attention" layout="record" items={attention} />
      <div className="grid min-w-0 gap-4 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
        <div className="min-w-0 space-y-4">{children}</div>
        {rail != null && (
          <aside aria-label="Related facts and activity" className="min-w-0 space-y-4">
            {rail}
          </aside>
        )}
      </div>
    </div>
  );
}
